// Auto generated by typegen from Prisma Schema

export enum PremiumSource {
	OP_LINE = "OP_LINE",
	SHIPPING_TIER = "SHIPPING_TIER",
}

export enum OrderRefundType {
	ITEM = "ITEM",
	SHIPPING = "SHIPPING",
	ORDER = "ORDER",
}

export enum SalesChannel {
	ONLINE = "ONLINE",
	IN_STORE = "IN_STORE",
}

export enum AttachWidgetType {
	CART = "CART",
	CHECKOUT = "CHECKOUT",
	INFO_MODAL = "INFO_MODAL",
	SUBSCRIPTION = "SUBSCRIPTION",
}

export enum ProductType {
	GROUPED = "GROUPED",
	CUSTOMIZABLE = "CUSTOMIZABLE",
	SIMPLE = "SIMPLE",
}

export enum ProductConnectionType {
	COMPONENT = "COMPONENT",
	BUNDLE = "BUNDLE",
	VARIANT = "VARIANT",
}

export enum ProductConnectionSource {
	SYNCED = "SYNCED",
	MANUAL = "MANUAL",
}

export enum InventoryTrackingType {
	SIMPLE = "SIMPLE",
	FULL = "FULL",
}

export enum ReturnProvider {
	parcellab = "parcellab",
	loopreturns = "loopreturns",
	refundid = "refundid",
}

export enum OrderItemAttributeType {
	OPTION = "OPTION",
	PROPERTY = "PROPERTY",
}

export enum TrackingAccountType {
	TRACKING_ONLY = "TRACKING_ONLY",
	POD_AND_TRACKING = "POD_AND_TRACKING",
}

export enum ActivityType {
	EVENT = "EVENT",
}

export enum ProductOptionType {
	DROPDOWN = "DROPDOWN",
	INPUT = "INPUT",
	RADIO_BUTTON = "RADIO_BUTTON",
}

export enum PriceType {
	FIXED = "FIXED",
	PERCENTAGE = "PERCENTAGE",
}

export enum ActivitySourceType {
	SYSTEM = "SYSTEM",
	OTHER = "OTHER",
}

export enum AddressOrigin {
	VALET = "VALET",
	CONCIERGE = "CONCIERGE",
	ORDER = "ORDER",
}

export enum AddressType {
	BILLING = "BILLING",
	SHIPPING = "SHIPPING",
}

export enum OneTimeAppeasement {
	ELIGIBLE = "ELIGIBLE",
	UNELIGIBLE = "UNELIGIBLE",
	IS_OTA = "IS_OTA",
}

export enum ProductStatus {
	ACTIVE = "ACTIVE",
	ARCHIVED = "ARCHIVED",
	DRAFT = "DRAFT",
	DELETED = "DELETED",
}

export enum WarrantyStatus {
	INCLUDED = "INCLUDED",
	EXCLUDED = "EXCLUDED",
}

export enum ProductSyncType {
	PRODUCT = "PRODUCT",
	WARRANTY = "WARRANTY",
	WARRANTY_EXCLUSION = "WARRANTY_EXCLUSION",
}

export enum ProductSyncSource {
	SHOPIFY = "SHOPIFY",
	CSV = "CSV",
}

export enum ProductSyncStatus {
	IN_PROGRESS = "IN_PROGRESS",
	COMPLETED = "COMPLETED",
	COMPLETED_WITH_ERRORS = "COMPLETED_WITH_ERRORS",
	FAILED = "FAILED",
	CANCELED = "CANCELED",
}

export interface Order {
	id: string;
	sourceOrderId: string;
	originalSourceOrderId: string | null;
	sourceOrderNumber: string | null;
	sourceCreatedAt: string;
	sourceUpdatedAt: string;
	sourceCancelledAt: string | null;
	policyCancelledAt: string | null;
	shippedAt: string | null;
	platformId: string;
	premiumPaid: number | null;
	premiumCost: number | null;
	premiumSource: PremiumSource;
	currency: string | null;
	total: number;
	discountTotal: number | null;
	shippingCost: number | null;
	shippingCostTax: number | null;
	tax: number | null;
	subtotal: number;
	customerEmail: string | null;
	customerName: string;
	customerPhone: string | null;
	exchangeRate: number | null;
	storeId: string;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	insuranceQuoteId: string | null;
	policyId: string | null;
	customerIp: string | null;
	eligibleForOta: OneTimeAppeasement;
	selectedProtection: string | null;
	salesChannel: SalesChannel;
	hasChargeback: boolean;
	attachWidgetType: AttachWidgetType | null;
	attachWidgetConfigurationId: string | null;
	sourceName: string | null;
	sourceAppId: string | null;
	shippingLines: OrderShippingLine[];
	originalOrderId: string | null;
	originalOrder: Order | null;
	orderItems: OrderItem[];
	activities: Activity[];
	address: Address[];
	fulfillments: Fulfillment[];
	refunds: OrderRefund[];
	customer: Customer | null;
	customerId: string | null;
	reshipments: Order[];
	returns: Return[];
}

export interface OrderShippingLine {
	id: string;
	orderId: string;
	code: string | null;
	title: string | null;
	source: string | null;
	carrier: string | null;
	deliveryCategory: string | null;
	price: number | null;
	createdAt: string;
	order: Order;
}

export interface OrderRefund {
	id: string;
	orderId: string;
	storeId: string;
	sourceRefundId: string;
	refundType: OrderRefundType;
	sourceItemId: string | null;
	amount: number;
	tax: number;
	refundedAt: string;
	createdAt: string;
	updatedAt: string | null;
	deletedAt: string | null;
	order: Order;
}

export interface Return {
	id: string;
	orderId: string;
	order: Order;
	status: string;
	orderNumber: string | null;
	returnNumber: string | null;
	trackingId: string | null;
	trackingNumber: string | null;
	trackingCarrier: string | null;
	trackingUrl: string | null;
	sourceCreatedAt: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	originZip: string | null;
	originCity: string | null;
	originCountry: string | null;
	originStreet: string | null;
	url: string | null;
	returnMethod: string | null;
	locale: string | null;
	email: string | null;
	labelUrl: string | null;
	labelCost: string | null;
	labelCurrency: string | null;
	provider: string;
	returnAddress: Address | null;
	returnAddressId: string | null;
	storeId: string | null;
	items: ReturnItem[];
}

export interface Product {
	id: string;
	storeId: string;
	productId: string;
	variantId: string | null;
	name: string | null;
	description: string | null;
	sku: string;
	price: number;
	tax: number;
	productImage: string | null;
	tags: string[];
	searchText: string | null;
	inventoryType: InventoryTrackingType;
	inventoryQuantity: number;
	inStock: boolean;
	status: ProductStatus;
	productType: ProductType;
	orderItem: OrderItem[];
	childProducts: ProductConnection[];
	parentProduct: ProductConnection[];
	parentId: string | null;
	parent: Product | null;
	variants: Product[];
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	productWarranty: ProductWarranty[];
	productOption: ProductOption[];
	warrantyStatus: WarrantyStatus;
	syncLogId: string | null;
	syncLog: ProductSyncLog | null;
}

export interface ProductConnection {
	productId: string;
	parentProductId: string;
	connectionType: ProductConnectionType;
	source: ProductConnectionSource;
	createdAt: string;
	child: Product;
	parent: Product;
}

export interface ProductOption {
	id: string;
	name: string;
	productId: string;
	optionId: string;
	required: boolean;
	type: ProductOptionType;
	product: Product;
	productOptionValue: ProductOptionValue[];
}

export interface ProductOptionValue {
	id: string;
	name: string;
	price: number;
	priceType: PriceType;
	sku: string | null;
	optionValueId: string;
	productOptionId: string;
	productOption: ProductOption;
}

export interface ProductWarranty {
	id: string;
	productId: string;
	validity: string;
	syncLogId: string | null;
	syncLog: ProductSyncLog | null;
	product: Product;
	createdAt: string;
	updatedAt: string;
	voidedAt: string | null;
	deletedAt: string | null;
}

export interface ReturnItem {
	id: string;
	returnId: string;
	productName: string;
	return: Return;
	orderItemId: string;
	orderItem: OrderItem;
	quantity: number;
	reason: string;
	reasonCode: string | null;
}

export interface ReturnSetting {
	id: string;
	storeId: string;
	trackingPortalUrl: string | null;
	returnPortalUrl: string | null;
	providerId: string | null;
	provider: ReturnProvider;
	enabled: boolean;
	updatedAt: string | null;
}

export interface CustomerAlias {
	id: string;
	customerId: string;
	firstName: string | null;
	lastName: string | null;
	email: string;
	phone: string | null;
	reasonForAlias: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	customer: Customer;
}

export interface Customer {
	id: string;
	firstName: string | null;
	lastName: string | null;
	email: string;
	phone: string | null;
	orders: Order[];
	aliases: CustomerAlias[];
	addresses: Address[];
	sourceId: string | null;
	createdAt: string;
	updatedAt: string | null;
}

export interface Address {
	id: string;
	firstName: string | null;
	lastName: string | null;
	company: string | null;
	address1: string | null;
	address2: string | null;
	city: string | null;
	state: string | null;
	stateAbr: string | null;
	zip: string | null;
	country: string | null;
	countryAbr: string | null;
	lat: number | null;
	lng: number | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	orderId: string;
	type: AddressType;
	order: Order;
	customer: Customer | null;
	customerId: string | null;
	userId: string | null;
	addressOrigin: AddressOrigin;
	return: Return[];
}

export interface OrderItem {
	id: string;
	orderId: string;
	order: Order;
	productName: string;
	productUrl: string | null;
	productImage: string | null;
	itemDescription: string | null;
	sku: string | null;
	quantity: number;
	price: number;
	discount: number;
	tax: number;
	sourceItemId: string | null;
	sourceProductId: string | null;
	sourceVariantId: string | null;
	createdAt: string;
	updatedAt: string;
	refundedQuantity: number | null;
	requiresShipping: boolean;
	manuallyAdded: boolean | null;
	productId: string | null;
	policyId: string | null;
	fulfillments: FulfillmentItem[];
	selectedOptions: OrderItemAttribute[];
	returnItem: ReturnItem[];
	product: Product | null;
	parentOrderItemId: string | null;
	parentOrderItem: OrderItem | null;
	childItems: OrderItem[];
}

export interface OrderItemAttribute {
	id: string;
	orderItemId: string;
	name: string;
	value: string;
	type: OrderItemAttributeType;
	item: OrderItem;
}

export interface Fulfillment {
	id: string;
	sourceFulfillmentId: string;
	fulfillmentStatus: string;
	trackingCompany: string | null;
	trackingNumber: string[];
	trackingUrl: string[];
	sourceOrderId: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	items: FulfillmentItem[];
	trackings: Tracking[];
	orderId: string;
	order: Order;
}

export interface Tracking {
	id: string;
	fulfillmentId: string;
	fulfillment: Fulfillment;
	storeId: string;
	trackingNumber: string;
	slug: string | null;
	provider: string;
	accountType: TrackingAccountType;
	tag: string | null;
	subtag: string | null;
	subtagMessage: string | null;
	signedBy: string | null;
	shipmentDeliveryDate: string | null;
	expectedDelivery: string | null;
	lastEventAt: string | null;
	rawPayload: object | null;
	createdAt: string;
	updatedAt: string;
	checkpoints: TrackingCheckpoint[];
	pods: TrackingPod[];
}

export interface TrackingCheckpoint {
	id: string;
	trackingId: string;
	tracking: Tracking;
	checkpointTime: string;
	tag: string | null;
	subtag: string | null;
	subtagMessage: string | null;
	message: string | null;
	location: string | null;
	city: string | null;
	state: string | null;
	zip: string | null;
	countryRegion: string | null;
	source: string | null;
	eventId: string | null;
	receivedAt: string;
}

export interface TrackingPod {
	id: string;
	trackingId: string;
	tracking: Tracking;
	type: string;
	url: string;
	receivedAt: string;
}

export interface FulfillmentItem {
	id: string;
	fulfillmentId: string;
	fulfillment: Fulfillment;
	quantity: number;
	orderItemId: string;
	item: OrderItem;
}

export interface Activity {
	id: string;
	message: string;
	imageUrl: string | null;
	username: string;
	sourceOrderId: string | null;
	orderId: string;
	order: Order;
	activityType: string;
	activitySourceType: string;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
}

export interface ProductSyncLog {
	id: string;
	storeId: string;
	type: ProductSyncType;
	source: ProductSyncSource | null;
	status: ProductSyncStatus;
	shopifyOperationId: string | null;
	createdAt: string;
	updatedAt: string;
	deletedAt: string | null;
	totalBatches: number | null;
	completedBatches: number;
	products: Product[];
	warranties: ProductWarranty[];
}

